import {
    Box, Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import React, {useState} from "react";
import Flag from 'react-world-flags'

function LanguageFreeSelectionDropdownView({confirmationCallback, cancelCallback}) {

    const languages = [
        { language: "Bulgarian", code: "bg" },
        { language: "Chinese", code: "cn" },
        { language: "Dutch", code: "nl" },
        { language: "French", code: "fr" },
        { language: "German", code: "de" },
        { language: "Hindi", code: "in" },
        { language: "Italian", code: "it" },
        { language: "Japanese", code: "jp" },
        { language: "Korean", code: "kr" },
        { language: "Portuguese", code: "pt" },
        { language: "Romanian", code: "ro" },
        { language: "Russian", code: "ru" },
        { language: "Spanish", code: "es" },
        { language: "Thai", code: "th" },
        { language: "Ukrainian", code: "ua" },
        { language: "Vietnamese", code: "vi" }
    ];

    const [chosenLanguage, setChosenLanguage] = useState('German');

    function dropdownView() {
        return (
            <Select
                value={chosenLanguage}
                onChange={e => setChosenLanguage(e.target.value)}
                sx={{width: 200}}
            >
                {languages.map(({language, code}, index) => (
                    <MenuItem key={index} value={language} sx={{width: 200}}>
                        <Box display="flex" alignItems="center">
                            <Flag code={code} height={30}/>
                            <Typography variant="body1" sx={{ml: 2}}>{language}</Typography>
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        )
    }

    return (
        <Dialog open={true} onClose={cancelCallback}>
            <DialogTitle>Select language</DialogTitle>
            <DialogContent >
                {dropdownView()}
            </DialogContent>
            <DialogActions>
                <Button color="inherit" onClick={cancelCallback}>
                    Cancel
                </Button>
                <Button color="purple" onClick={() => {
                    const code = languages.find(({language, code}) => language === chosenLanguage).code;
                    confirmationCallback({language: chosenLanguage, code: code});
                }}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )

}

export default LanguageFreeSelectionDropdownView;